import { useCallback } from "react";
export const showUpsellModalKey = "showUpsellModalKey";

export function useUpsellModal() {
  const getSessionStorage = () => {
    if (!sessionStorage) return null;
    return sessionStorage;
  };

  const setShouldShowUpsellModal = useCallback((value: string) => {
    try {
      getSessionStorage()?.setItem(showUpsellModalKey, value);
    } catch (e) {
      //eslint-disable-next-line no-console
      console.error("Error setting item in sessionStorage:", e);
    }
  }, []);

  const getUpsellModalValue = useCallback((): string | null => {
    try {
      const item = getSessionStorage()?.getItem(showUpsellModalKey);
      return item ? item : null;
    } catch (e) {
      return null;
    }
  }, []);

  return {
    setShouldShowUpsellModal,
    getUpsellModalValue
  };
}
